export const STATUS_COLORS = {
  adopted: "green", existing: "green", none_proceedings: "green", high: "green", low: "green",
  draft: "yellow", consultation: "yellow", in_progress: "yellow", upcoming: "yellow",
  medium: "yellow", expired_studium: "yellow", elevated: "yellow",
  pending: "red", active: "red", none: "gray", unknown: "gray", closed: "gray",
  DETECTED: "yellow", NOT_DETECTED: "green", SOURCE_UNAVAILABLE: "gray",
  NEARBY: "yellow",
  INSUFFICIENT_DATA: "gray", REQUIRES_PROFESSIONAL_VERIFICATION: "gray",
};

const COLOR_CLASSES = {
  green: "bg-emerald-100 text-emerald-800 border-emerald-200",
  yellow: "bg-amber-100 text-amber-800 border-amber-200",
  red: "bg-rose-100 text-rose-800 border-rose-200",
  gray: "bg-slate-100 text-slate-600 border-slate-200",
};

export const MAP_DOT_COLORS = {
  adopted: "#059669", draft: "#D97706", consultation: "#DC143C", pending: "#64748B", unknown: "#CBD5E1",
  gotowa: "#059669", w_trakcie: "#D97706", ograniczona: "#0284C7", brak_danych: "#94A3B8",
  nie_wykryto: "#64748B", zrodlo_niedostepne: "#CBD5E1",
};

export function StatusBadge({ status, label, testId }) {
  const color = STATUS_COLORS[status] || "gray";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${COLOR_CLASSES[color]}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label || status}
    </span>
  );
}

export function DemoRibbon({ label }) {
  return (
    <span
      data-testid="demo-data-ribbon"
      className="inline-flex items-center rounded border border-dashed border-slate-400 bg-slate-50 px-1.5 py-px text-[9px] font-bold uppercase tracking-widest text-slate-500"
    >
      {label}
    </span>
  );
}
